import Vue from 'vue'
import {
  VApp, // required
  VNavigationDrawer,
  VFooter,
  VToolbar,
  VBtn,
  VIcon,
  VList,
  VDivider,
  VForm,
  VTextField,
  VSelect,
  VCheckbox,
  VRadioGroup,
  VProgressCircular,
  VDataTable,
  VDialog,
  VCard,
  VSpeedDial,
  VTabs,
  VMenu,
  VSubheader,
  VSwitch,
  VAlert,
  VSnackbar

} from 'vuetify/lib'
import Vuetify from 'vuetify'
import VGrid from 'vuetify/lib/components/VGrid/'
import transitions from 'vuetify/lib/components/transitions/'

import 'vuetify/src/styles/main.sass'
Vue.use(Vuetify)
export default new Vuetify({
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VToolbar,
    transitions,
    VGrid,
    VBtn,
    VIcon,
    VList,
    VDivider,
    VForm,
    VTextField,
    VSelect,
    VCheckbox,
    VRadioGroup,
    VProgressCircular,
    VDataTable,
    VDialog,
    VCard,
    VSpeedDial,
    VTabs,
    VMenu,
    VSubheader,
    VSwitch,
    VAlert,
    VSnackbar
  },
  icons: {
    iconfont: 'md'
  },
  theme: {
    themes: {
      light: {
        primary: '#00809B',
        secondary: '#BAB3FF',
        accent: '#FFBE1D',
        error: '#C8102A',
        warning: '#F65835',
        info: '#F2F1EF',
        success: '#3F7E25'
      }
    }
  }
})
